import { AppEnv } from '../../appConfig/appConfig.types';
import { IFeatureToggles } from '../featureToggles.types';
import { featureTogglesDefault } from './default';

/**
 * Specific hard-coded Dev overrides to ./default.ts.
 *
 * For more info, see https://chalk.charter.com/display/ERSPM/FE+Configs
 */
export const featureTogglesDev: IFeatureToggles = {
  environment: AppEnv.Dev,
  toggles: [...featureTogglesDefault.toggles],
};
